<template>
	<page gradient-background>
		<detail-base :count="{name: '预估收费', value: `￥${baseInfo.estimated_fee || '-'}`}">
			<template #state>
				<c-state dict="orderTransferStatusDic" tag :value="baseInfo.order_transfer_status"></c-state>
				<c-state dict="serviceTypeDic" tag :value="baseInfo.service_type_code"></c-state>
			</template>

			<template #title><i class="tf">&#xe67c;</i> {{baseInfo.customer_name}}</template>

			<template #info>
				<c-field v-if="baseInfo.work_order_no" label="关联工单"><c-link v-if="baseInfo.work_order_id" @click="mp.navigateWeb('/aftersales/work/detail', {id: baseInfo.work_order_id})">{{baseInfo.work_order_no}}</c-link></c-field>
				<c-field label="客户电话"><a v-if="baseInfo.customer_phone" :href="`tel:${baseInfo.customer_phone}`">{{baseInfo.customer_phone}} [{{baseInfo.customer_contact}}]<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-field>
				<c-field label="售后地址"><a @click="mapHandle">{{baseInfo.aftersale_address}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe6d7;</i></a></c-field>
				<c-field label="分配网点">{{baseInfo.authorized_outlet_name}}</c-field>
			</template>
		</detail-base>

		<detail-content>
			<c-title>基础信息</c-title>
			<c-detail>
				<c-detail-item label="申请单编号">{{baseInfo.aftersale_apply_no}}</c-detail-item>
				<c-detail-item label="申请单状态">{{baseInfo.apply_status}}</c-detail-item>
				<c-detail-item label="服务类型">{{baseInfo.service_type}}</c-detail-item>
				<c-detail-item label="售后类别"><c-state dict="afterSaleTypeDic" :value="baseInfo.aftersale_type_code"></c-state></c-detail-item>
				<c-detail-item label="服务内容">{{baseInfo.service_content}}</c-detail-item>
				<c-detail-item label="是否收费">{{baseInfo.is_charge}}</c-detail-item>
				<c-detail-item label="预估收费金额">￥{{baseInfo.estimated_fee}}</c-detail-item>
				<c-detail-item label="预估人数">{{baseInfo.estimated_person}}</c-detail-item>
				<c-detail-item label="预估到达时间">{{baseInfo.eost_date}}</c-detail-item>
				<c-detail-item label="备注">{{baseInfo.remark}}</c-detail-item>
			</c-detail>

			<c-title>客户信息</c-title>
			<c-detail>
				<c-detail-item label="客户名称">{{baseInfo.customer_name}}</c-detail-item>
				<c-detail-item label="所属部门">{{baseInfo.depart_name}}</c-detail-item>
				<c-detail-item label="联系人">{{baseInfo.customer_contact}}</c-detail-item>
				<c-detail-item label="联系电话"><a v-if="baseInfo.customer_phone" :href="`tel:${baseInfo.customer_phone}`">{{baseInfo.customer_phone}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-detail-item>
				<c-detail-item label="售后地址">{{baseInfo.aftersale_address}}</c-detail-item>
				<c-detail-item label="地址定位">{{baseInfo.address_longitude}}, {{baseInfo.address_latitude}}</c-detail-item>
				<c-detail-item label="网点-客户距离">{{baseInfo.net_address_count}}km</c-detail-item>
			</c-detail>

			<c-title>业务信息</c-title>
			<c-detail>
				<c-detail-item label="服务类别">{{baseInfo.service_category}}</c-detail-item>
				<c-detail-item label="业务员姓名">{{baseInfo.salesman_name}}</c-detail-item>
				<c-detail-item label="业务员电话"><a v-if="baseInfo.salesman_phone" :href="`tel:${baseInfo.salesman_phone}`">{{baseInfo.salesman_phone}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-detail-item>
				<c-detail-item label="申请单所有人">{{baseInfo.apply_owner}}</c-detail-item>
				<c-detail-item label="创建时间">{{baseInfo.apply_create_time}}</c-detail-item>
				<c-detail-item label="审核人">{{baseInfo.apply_auditor}}</c-detail-item>
				<c-detail-item label="审核时间">{{baseInfo.apply_audit_time}}</c-detail-item>
			</c-detail>

			<c-title>售后服务明细 ({{productList.length}})</c-title>
			<div>
				<goods-card
					v-for="(item, i) in productList"
					:key="i"
					:index="i + 1"
					:title="`${item.inventory_name || '-'} ${item.spec_model != item.inventory_name ? item.spec_model || '-' : ''}`"
					:info="[
						`长：${item.length || '-'}mm`,
						`宽：${item.width || '-'}mm`,
						`件数：${item.quantity || '-'}`,
						`环接方式：${item.connection_method || '-'}`,
						`数量：${item.pieces || '-'}`
					]"
					:remark="item.item_remark"
				></goods-card>
			</div>
		</detail-content>

		<detail-handle>
			<template>
				<c-button v-if="auth('b_app_aftersale_apply_transfer') && baseInfo.order_transfer_status == 0" size="detail" color="main" @click="mp.navigateWeb('/aftersales/work/edit', {source: baseInfo.id})">转售后工单</c-button>
				<c-button v-if="auth('b_app_aftersale_apply_authorize') && baseInfo.order_transfer_status == 0" @click="$refs.applyAllot.open(baseInfo.id)">分配网点</c-button>
			</template>
		</detail-handle>

		<apply-allot ref="applyAllot" @resolve="update"></apply-allot>
	</page>
</template>

<script>
	import applyAllot from './apply_allot.vue'

	export default {
		components: {
			applyAllot
		},
		
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {},
				productList: []
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/aftersale/apply/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, itemList}) => {
						this.baseInfo = detailInfo;
						this.productList = itemList;
					}
				})
			},

			mapHandle() {
				this.mp.navigateTo('/pages/power', {
					power: 'openLocation',
					data: `${this.baseInfo.address_longitude},${this.baseInfo.address_latitude}`
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.customer {
		gap: .26rem;

		&-count {
			gap: .12rem;
			width: 1rem;
			height: 1rem;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			background: var(--color-main);

			b {
				font-size: .36rem;
			}
		}

		&-name {
			font-size: .32rem;
			color: #28324B;
		}

		&-tag {
			gap: .12rem;
			margin-top: .2rem;
		}
	}
</style>